import React, { useEffect, useState } from "react"
import styled from "styled-components"
import ChatItem from "../components/ChatItem"
import { FaUserFriends } from "react-icons/fa"
import { FiSearch } from "react-icons/fi"
import ChatDetailItem from "../components/ChatDetailItem"
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore"
import { db, useAuth } from "../firebase-config"

const ChatScreenMobo = () => {
  const [selectedChat, setSelectedChat] = useState(null)
  const [usersArr, setUsersArr] = useState([])
  const [msgs, setMsgs] = useState([])
  const currentUser = useAuth()
  const user1 = currentUser?.uid
  let placeholderAvatar =
    "https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png"

  const handleChatItemClick = async item => {
    setSelectedChat(item)
    console.log(item)
    const user2 = item?.uid
    const id = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`

    const msgsRef = collection(db, "messages", id, "chat")
    const q = query(msgsRef, orderBy("createdAt", "asc"))

    onSnapshot(q, querySnapshot => {
      let msgs = []
      querySnapshot.forEach(doc => {
        msgs.push(doc.data())
      })
      setMsgs(msgs)
      console.log(msgs)
    })
    // get last message b/w logged in user and selected user
    // const docSnap = await getDoc(doc(db, "lastMsg", id));
    // if last message exists and message is from selected user
    // if (docSnap.data() && docSnap.data().from !== user1) {
    // update last message doc, set unread to false
    //   await updateDoc(doc(db, "lastMsg", id), { unread: false });
    // }
  }
  useEffect(() => {
    const userRef = collection(db, "users")
    if(currentUser.uid){
        const q = query(userRef, where("uid", "!=", currentUser?.uid))
        const unsub = onSnapshot(q, querySnapshot => {
            let users = []
          querySnapshot.forEach((doc) => {
            users.push(doc.data())
          })
          setUsersArr(users)
        })
        console.log(usersArr)
        return unsub
    }
        
  }, [currentUser?.uid])

  return (
    <>
      <ChatComp>
        {!selectedChat && (
          <ChatListCont>
            <ChatHeader>
              <label htmlFor="">Chats</label>
              <FaUserFriends size={25} color="#000" />
            </ChatHeader>
            <ChatSearchBox>
              <FiSearch size={20} color="#888888" />
              <SearchInput></SearchInput>
            </ChatSearchBox>
            {usersArr.length != 0 &&
              usersArr.map((item, index) => {
                return (
                  <ChatItem
                    key={index}
                    user1={user1}
                    user={item}
                    handleChatClick={() => handleChatItemClick(item)}
                    chatPersonImg={item?.personalInfo?.profilePic? item.personalInfo.profilePic : placeholderAvatar}
                    chatPersonName={item.personalInfo.name}
                  />
                )
              })}
          </ChatListCont>
        )}

        {selectedChat ? (
          <ChatDetailsCont>
            <ChatDetailItem  convo={msgs} user={selectedChat} />
          </ChatDetailsCont>
        ) : null}
      </ChatComp>
    </>
  )
}

export default ChatScreenMobo

const ChatComp = styled.div`
  display: flex;
  background: var(--white);
  width: 80%;
  margin-top: 2rem;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0rem;
  }
`
const ChatListCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  max-width: 30%;
  align-items: center;
  overflow-y: auto;
  background: ${({ theme }) => theme.background};
  overflow-y: auto;
  height: 90vh;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--p-red);
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
  }
`
const ChatDetailsCont = styled.div`
  display: flex;
  width: 70%;
  max-width: 70%;
  background: ${({ theme }) => theme.body};
  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
    height: 95vh;
  }
`

const ChatHeader = styled.div`
  display: none;
  justify-content: space-between;
  width: 87%;
  padding: 1rem 0rem;
  label {
    font-size: 1.2rem;
    font-weight: 500;
  }
`
const ChatSearchBox = styled.div`
  display: flex;
  background: ${({ theme }) => theme.body};
  border: 1px solid ${({ theme }) => theme.background};
  border-radius: 5px;
  width: 85%;
  height: 2rem;
  align-items: center;
  padding: 0.5rem;
  box-shadow: 20px 20px 80px rgba(0, 0, 0, 0.1);
  padding-right: 1rem;
  margin: 1rem 0rem;
`

const SearchInput = styled.input`
  background: ${({ theme }) => theme.body};
  border: none;
  width: 100%;
  padding-left: 0.5rem;
  :focus {
    outline: none;
  }
`
